import React from 'react'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// hooks
import { useShowModal } from 'hooks'
// constants
import { Modals } from 'constants/modals'

const CreateActionButton: React.FC = () => {
  const { showModal } = useShowModal({ modalType: Modals.ACTION_CREATE_MODAL })

  const createAction = () => showModal()

  return (
    <Button style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.PURPLE} onClick={createAction}>
      Create Action
    </Button>
  )
}

export default CreateActionButton
